export default function ProductsIcon({ className }: any) {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M15.1667 12.3C15.1667 11.3059 15.9726 10.5 16.9667 10.5H36.7C37.6941 10.5 38.5 11.3059 38.5 12.3V26.8333H16.9667C15.9726 26.8333 15.1667 26.0274 15.1667 25.0333V12.3Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M10.5 28.633C10.5 27.6389 11.3059 26.833 12.3 26.833H29.1667V45.4997H12.3C11.3059 45.4997 10.5 44.6938 10.5 43.6997V28.633Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M29.1667 26.833H46.0333C47.0275 26.833 47.8333 27.6389 47.8333 28.633V43.6997C47.8333 44.6938 47.0274 45.4997 46.0333 45.4997H29.1667V26.833Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path d="M38.5 26.833V33.833" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M19.8333 26.833V33.833" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M26.8333 10.5V17.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
